import React, { useEffect, useState } from "react";
import styledComp from "styled-components";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  OutlinedInput,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import InputAdornment from "@mui/material/InputAdornment";
import { openFormApi, submitFormApi } from "../../../Api";
import { getDisclaimerHtml } from "../../../Functions";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "80vh",
  width: "100%",
  textAlign: "left",
  padding: theme.spacing(2),
  borderRadius: "5px",
  backgroundColor: "white",
  position: "relative",
}));
const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: "white",
  zIndex: 2,
}));
const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  bottom: 0,
  backgroundColor: "white",
  paddingTop: theme.spacing(2),
  zIndex: 2,
  width: "100%",
}));

const Header = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  textAlign: "left",
  width: "100%",
  marginBottom: theme.spacing(2),
  variant: "h6",
  component: "span",
  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 600 16px Poppins",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 600 18px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 600 22px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 600 28px Poppins",
  },
}));


const Label = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 12px Poppins",
  color: "#040807",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 400 12px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 12px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 14px Poppins",
  },
}));

const DescText = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 12px Poppins",
  color: "#5a6066",
  variant: "body1",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 10px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 12px Poppins",
  },
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 12px Poppins",
  textAlign: "left",
  color: "#353535",
  variant: "caption",
  component: "span",
  [[theme.breakpoints.between("xs", "md")]]: {
    font: "normal normal 500 8px Poppins",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 500 10px Poppins",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 500 12px Poppins",
  },
}));

const CountryCode = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 14px Poppins",
  textAlign: "center",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));

const Form = styledComp.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const InputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "white",
  width: " 100%",
  borderRadius: "8px",
  height: "30px",
  overflow: "hidden",
}));

const FieldWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));
const ThankYouWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(2),
}));
const ThankYouMessage = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  whiteSpace: "pre-line",
  textAlign: "left",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));
const DisclaimerWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: "10px",
  width: "100%",
  marginBottom: theme.spacing(2),
}));
const Message = styled(Typography)(({ theme }) => ({
  font: "normal normal 500 18px Poppins",
  textAlign: "center",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));
const FieldsWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: "auto",
  paddingTop: "12px",
  paddingBottom: "12px",
  paddingRight: "4px",
}));
const FormComponent = ({ formState, secondaryColor, contentState }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const [details, setDetails] = useState({});
  const [isCheckedDisclaimer, setIsCheckedDisclaimer] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const getLabelName = (meta) => {
    if (meta["required"] === true) {
      return `${meta["label"]}*`;
    } else {
      return meta["label"];
    }
  };

  const handleSubmit = async () => {
    let formData = { payload: { ...details } };
    if (details.hasOwnProperty("phone")) {
      formData["payload"]["phone"] = `+91-${details["phone"]}`;
    }
    if (details.hasOwnProperty("phone")) {
      formData["target"] = `+91-${details["phone"]}`;
    } else if (details.hasOwnProperty("email")) {
      formData["target"] = details["email"];
    } else {
      formData["target"] = "";
    }
    let response = await submitFormApi({
      formID: queryParams.get("form_id"),
      payload: formData,
    });
    setIsSubmitted(true);
  };

  const handleChange = (event) => {
    setDetails({ ...details, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    openFormApi({ formID: queryParams.get("form_id") });
  }, []);

  return (
    <>
      <Container>

        {!isSubmitted ? <> <HeaderWrapper>
          <Header
            sx={{
              color: secondaryColor,
            }}
          >
            {contentState.form_title}
          </Header>
        </HeaderWrapper>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <FieldsWrapper>
              <Grid container spacing={1.5}>
                {formState.map((fieldMeta, index) => {
                  if (fieldMeta["field_type"] === "phone") {
                    return (
                      <Grid item xs={12} key={index}>
                        <FieldWrapper>
                          <Label>{getLabelName(fieldMeta)}</Label>
                          {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                            <DescText>{fieldMeta.desc}</DescText>}
                          <InputWrapper>
                            <OutlinedInput
                              disabled={isSubmitted}
                              autoComplete="off"
                              required={fieldMeta["required"]}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "^[0-9]{10}$",
                                maxLength: 10,
                              }}
                              startAdornment={
                                <InputAdornment position="start">
                                  <CountryCode>+91</CountryCode>
                                </InputAdornment>
                              }
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              name={fieldMeta["field_name"]}
                              style={{
                                width: "100%",
                                borderRadius: "8px",
                                font: "normal normal 400 14px Poppins",
                              }}
                            />
                          </InputWrapper>
                        </FieldWrapper>
                      </Grid>
                    );
                  } else if (fieldMeta["field_type"] === "email") {
                    return (
                      <Grid item xs={12} key={index}>
                        <FieldWrapper>
                          <Label>{getLabelName(fieldMeta)}</Label>
                          {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                            <DescText>{fieldMeta.desc}</DescText>}
                          <InputWrapper>
                            <OutlinedInput
                              disabled={isSubmitted}
                              required={fieldMeta["required"]}
                              autoComplete="off"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              type="email"
                              style={{
                                width: "100%",
                                height: "30px",
                                borderRadius: "8px",
                                font: "normal normal 400 14px Poppins",
                              }}
                              onChange={handleChange}
                            />
                          </InputWrapper>
                        </FieldWrapper>
                      </Grid>
                    );
                  } else if (fieldMeta["field_type"] === "text") {
                    return (
                      <Grid item xs={12} key={index}>
                        <FieldWrapper>
                          <Label>{getLabelName(fieldMeta)}</Label>
                          {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                            <DescText>{fieldMeta.desc}</DescText>}
                          <InputWrapper>
                            <OutlinedInput
                              disabled={isSubmitted}
                              autoComplete="off"
                              required={fieldMeta["required"]}
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              style={{
                                width: "100%",
                                height: "30px",
                                borderRadius: "8px",
                                font: "normal normal 400 14px Poppins",
                              }}
                              onChange={handleChange}
                            />
                          </InputWrapper>
                        </FieldWrapper>
                      </Grid>
                    );
                  } else if (fieldMeta["field_type"] === "integer") {
                    return (
                      <Grid item xs={12} key={index}>
                        <FieldWrapper>
                          <Label>{getLabelName(fieldMeta)}</Label>
                          {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                            <DescText>{fieldMeta.desc}</DescText>}
                          <InputWrapper>
                            <OutlinedInput
                              disabled={isSubmitted}
                              autoComplete="off"
                              required={fieldMeta["required"]}
                              type="number"
                              inputProps={{
                                inputMode: "numeric",
                              }}
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              style={{
                                width: "100%",
                                borderRadius: "8px",
                                font: "normal normal 400 14px Poppins",
                              }}
                              onChange={handleChange}
                            />
                          </InputWrapper>
                        </FieldWrapper>
                      </Grid>
                    );
                  } else if (fieldMeta["field_type"] === "dropdown") {
                    return (
                      <Grid item xs={12} key={index}>
                        <FieldWrapper>
                          <Label>{getLabelName(fieldMeta)}</Label>
                          {fieldMeta.hasOwnProperty("desc") && fieldMeta.desc &&
                            <DescText>{fieldMeta.desc}</DescText>}

                          <FormControl
                            sx={{
                              width: "100%",
                              height: "30px",
                              backgroundColor: "white",
                              borderRadius: "8px",
                            }}
                          >
                            <Select
                              style={{
                                width: "100%",
                                height: "30px",
                                font: "normal normal 400 14px Poppins",
                              }}
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              MenuProps={{
                                disableScrollLock: true,
                              }}
                              required={fieldMeta["required"]}
                              inputProps={{
                                "aria-label": "Without label",
                                style: { borderColor: "transparent" },
                              }}
                              onChange={handleChange}
                              disabled={isSubmitted}
                            >
                              {fieldMeta["inputs"].map((item) => {
                                return (
                                  <MenuItem
                                    style={{
                                      font: "normal normal 400 14px Poppins",
                                    }}
                                    value={item}
                                  >
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </FieldWrapper>
                      </Grid>
                    );
                  }
                })}
              </Grid>
            </FieldsWrapper>
            <ButtonWrapper>
              <DisclaimerWrapper>
                <FormControlLabel
                  disabled={isSubmitted}
                  sx={{
                    alignItems: "flex-start",
                    margin: 0,
                  }}
                  onChange={() => {
                    setIsCheckedDisclaimer(!isCheckedDisclaimer);
                  }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={isCheckedDisclaimer}
                      sx={{
                        paddingTop: "0px",
                      }}
                    />
                  }
                  label={
                    <Box
                      sx={{
                        fontSize: "12px",
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 500,
                        color: "#353535",
                        margin: 0,
                        "& p": {
                          fontFamily: "inherit",
                          fontWeight: "inherit",
                          fontSize: "inherit",
                          margin: 0,
                        },
                        "& div": {
                          margin: 0,
                        },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: getDisclaimerHtml(contentState.disclaimer),
                      }}
                    />
                  }
                />
              </DisclaimerWrapper>
              <Button
                fullWidth
                disabled={!isCheckedDisclaimer || isSubmitted}
                variant="contained"
                color="primary"
                type="submit"
                style={{
                  textTransform: "none",
                  color: "white",
                  font: "normal normal 700 16px open sans",
                }}
              >
                APPLY NOW
              </Button>
            </ButtonWrapper>

          </Form>
        </> :
          <ThankYouWrapper>
            <ThankYouMessage>{contentState.thankyou_message}</ThankYouMessage>
          </ThankYouWrapper>
        }
      </Container>
    </>
  );
};

export default FormComponent;
